// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetCampaignQueryVariables = Types.Exact<{
  mid?: Types.InputMaybe<Types.Scalars['String']['input']>;
  product?: Types.InputMaybe<Types.ProductType>;
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetCampaignQuery = {
  __typename?: 'Query';
  results?: {
    __typename?: 'PurchaseWebCampaignOffer';
    id: string;
    campaignType: Types.PurchaseWebCampaignType;
    campaignIdentifier: string;
    endsAt?: string | null;
    startsAt: string;
    textValues: {
      __typename?: 'PurchaseWebTextValues';
      heading: string;
      subheading: string;
      benefits: Array<string>;
      legalNotice: string;
    };
    contracts: Array<{
      __typename?: 'PurchaseWebContract';
      id: string;
      orderType: Types.PurchaseOrderType;
      initialDuration: number;
      renewalDuration: number;
      featureSet: string;
      campaignIdentifier: string;
      duration: number;
      price: {
        __typename?: 'PurchaseWebPrice';
        initial: number;
        renewal: number;
        currency: Types.PurchaseWebCurrency;
        current?: number | null;
      };
    }>;
  } | null;
};

export const GetCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'product' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProductType' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'language' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'purchaseWebCampaignOffer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'mid' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'product' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'product' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'language' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'campaignType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'campaignIdentifier' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heading' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subheading' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'benefits' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'legalNotice' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startsAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contracts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WebContract' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebPrice' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PurchaseWebPrice' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'initial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renewal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'current' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebContract' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PurchaseWebContract' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renewalDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureSet' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignIdentifier' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WebPrice' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCampaignQuery, GetCampaignQueryVariables>;
